<template>
  <div class="vch-video-content">
    <div class="vch-video-content__preview vch-image-content" v-if="showPreview" @click="showPlayer"
      @keypress.space="showPlayer" @keypress.enter="showPlayer" role="button" tabindex="0">
      <slot />
      <div class="vch-video-content__video-decoration">
        <svg role="img" :aria-label="playVideoAriaLabel">
          <use href="/assets/sprite/icons.svg#element-play"></use>
        </svg>
      </div>
    </div>
    <div class="vch-video-content__video" v-if="!showPreview">
      <div class="vch-video-content__player">
        <iframe v-if="videoSrc" :src="videoSrc" title="YouTube video player" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>
      </div>
    </div>
    <div class="vch-video-content__transcript mt-xxs" v-if="transcript">
      <details class="vchy-details vchy-details--transcript" v-vch-accordion>
        <summary class="vchy-details__summary">
          <span>{{ transcriptHeader }}</span>
          <svg class="vchy-details__toggle" aria-hidden="true" width="24" height="24">
            <use href="/assets/sprite/icons.svg#arrow-black"></use>
          </svg>
        </summary>
        <div class="vchy-details__contents">
          <p class="text-large mb-xxs" v-html="transcript" />
        </div>
      </details>
    </div>
  </div>
</template>

<script>
export default {
  name: 'vch-video-content',
  props: {
    videoId: {
      type: String,
    },
    privateBrowsing: {
      type: Boolean,
      required: false,
      default: false,
    },
    transcriptHeader: {
      type: String,
      required: true,
    },
    transcript: {
      type: String,
      required: false,
    },
    playVideoAriaLabel: {
      type: String,
      default: 'video',
    },
  },

  data() {
    return {
      showPreview: true,
    };
  },
  computed: {
    videoSrc() {
      if (!this.videoId) return;
      return `https://www.${this.privateBrowsing ? 'youtube-nocookie' : 'youtube'
        }.com/embed/${this.videoId}?autoplay=1`;
    },
  },
  methods: {
    showPlayer() {
      this.showPreview = false;
    },
  },
};
</script>
<style lang="scss" src="./video-content.scss"></style>
